(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-embed"] && !Shopify.designMode) return;
  try {
    
  (function () {

    /* ── Swiper init ─────────────────────────────────────── */
    function initSwiper(sectionId) {
      var el = document.getElementById('shoppable-swiper-' + sectionId);
      if (!el || typeof Swiper === 'undefined') return;
      new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 4,
      mousewheel: {
          forceToAxis: true,
          sensitivity: 0.3,       
          releaseOnEdges: true,
          thresholdDelta: 20,     
          thresholdTime: 100     
        },
        grabCursor: true,
        freeMode: { enabled: true, sticky: false },
        breakpoints: { 990: { spaceBetween: 16 } }
      });
    }

    /* ── Sound toggle ────────────────────────────────────── */
    function initSoundButtons(sectionEl) {
      sectionEl.querySelectorAll('.peep-shoppable-video__sound_buttons').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var card    = btn.closest('.peep-shoppable-video__card');
          var section = btn.closest('.peep-shoppable-video');
          var video   = card.querySelector('video');
          if (!video) return;

          if (card.classList.contains('sound-on')) {
            video.muted = true;
            card.classList.remove('sound-on');
          } else {
            var active = section.querySelector('.peep-shoppable-video__card.sound-on');
            if (active) {
              var av = active.querySelector('video');
              if (av) av.muted = true;
              active.classList.remove('sound-on');
            }
            video.muted = false;
            card.classList.add('sound-on');
          }
        });
      });
    }

    /* ── Lazy play ─────────────────────────────────────────
       Videos download nothing until their card nears the screen, play while
       visible and pause when scrolled away. Autoplay started three 1080p
       downloads at page open, and they held the store's connection for about
       15 s: size taps on the product page and cart checks queued behind them. */
    function initLazyPlay(sectionEl) {
      var videos = sectionEl.querySelectorAll('video[data-lazy-play]');
      if (!videos.length) return;
      if (!('IntersectionObserver' in window)) {
        videos.forEach(function (v) { v.preload = 'auto'; v.play().catch(function () {}); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            v.preload = 'auto';
            v.play().catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { rootMargin: '200px 0px' });
      videos.forEach(function (v) { io.observe(v); });
    }

    /* ── Bootstrap ───────────────────────────────────────── */
    function bootstrap() {
      document.querySelectorAll('.peep-shoppable-video').forEach(function (sectionEl) {
        var id = sectionEl.id.replace('ShoppableVideoEmbeds-', '');
        initSoundButtons(sectionEl);
        initLazyPlay(sectionEl);

        if (typeof Swiper !== 'undefined') {
          initSwiper(id);
        } else {
          var script = document.querySelector('script[src*="swiper-bundle.min.js"]');
          if (script) script.addEventListener('load', function () { initSwiper(id); });
        }
      });
    }

    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', bootstrap)
      : bootstrap();

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-product-grid"] && !Shopify.designMode) return;
  try {
    
  function initTabbedProductGrid(section) {
    const tabsContainer = section.querySelector('.tpg-tabs');
    const panels = section.querySelectorAll('[data-panel]');
    const viewAllBtns = section.querySelectorAll('[data-view-all]');

    if (!tabsContainer || panels.length === 0) return;

    tabsContainer.innerHTML = '';

    panels.forEach((panel, index) => {
      const blockId = panel.dataset.panelIndex;
      const titleEl = panel.querySelector('[data-panel-title]');
      const tabName = titleEl ? titleEl.innerHTML.trim() : 'Tab';

      const button = document.createElement('button');

      button.className = 'tpg-tab';
      button.setAttribute('role', 'tab');
      button.setAttribute('data-tab-index', blockId);
      button.id = `tpg-tab-${section.id}-${blockId}`;
      button.setAttribute('aria-controls', `tpg-panel-${section.id}-${blockId}`);

      button.innerHTML = tabName;

      if (index === 0) {
  button.classList.add('tpg-tab--active');
  button.setAttribute('aria-selected', 'true');
  panel.classList.add('tpg-panel--active');

  viewAllBtns.forEach((btn) => {
    btn.href = panel.dataset.collectionUrl || '#';
  });
} else {
        button.setAttribute('aria-selected', 'false');
        panel.classList.remove('tpg-panel--active');
      }

      const blockWrapper = panel.closest('[data-shopify-editor-block]');

      if (blockWrapper) {
        const editorBlockData = blockWrapper.getAttribute('data-shopify-editor-block');

        if (editorBlockData) {
          button.setAttribute('data-shopify-editor-block', editorBlockData);
        }
      }

      button.addEventListener('click', () => {
        tabsContainer.querySelectorAll('.tpg-tab').forEach((tab) => {
          tab.classList.remove('tpg-tab--active');
          tab.setAttribute('aria-selected', 'false');
        });

        panels.forEach((p) => {
          p.classList.remove('tpg-panel--active');
        });

        button.classList.add('tpg-tab--active');
        button.setAttribute('aria-selected', 'true');
        panel.classList.add('tpg-panel--active');

    viewAllBtns.forEach((btn) => {
  btn.href = panel.dataset.collectionUrl || '#';
});
      });

      tabsContainer.appendChild(button);
    });
  }

  document.querySelectorAll('.tpg-section').forEach((section) => {
    initTabbedProductGrid(section);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.tpg-section');

    if (section) {
      initTabbedProductGrid(section);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
